import { Component, Inject, inject, OnInit } from '@angular/core';
import { AmplifyUser } from '@aws-amplify/ui';
import { ConfigService } from '../../../config.service';
import { MatDialog } from '@angular/material/dialog';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { Router,ActivatedRoute} from '@angular/router';
import { Auth } from 'aws-amplify';
import { GlobalDataService } from '../../../services/global-data.service';
import { detectEnv } from 'src/app/services/Enviroment';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from "../../../services/auth.service";
import { BoRolesCheckService } from 'src/app/components/rolesCheck/bo-roles-check.service';

@Component({
  selector: 'app-backoffice-transactions',
  templateUrl: './Transacciones.component.html',
  styles: [
    `
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
    `,
  ],
})
export class TransaccionesComponent implements OnInit {
  showSpinner = false;
  window = window;
  dialog = inject(MatDialog);
  lambda = inject(AWSLambda);
  rolesCheck = inject(BoRolesCheckService);
  protected currentEnv = detectEnv();
  user!: AmplifyUser;
  canAccess = false;
  balanceAmount: number | null = null;
  owner: string | null = null; 

  // Propiedades para manejar transacciones
  transactionList: any[] = [];
  paginationToken: string | null = null;
  hasMoreTransactions: boolean = true;
  loadingTransactions: boolean = false;
  filteredCounts: { transactionList: number } = { transactionList: 0 };
  filterTransactions: any[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private auth: AuthService,
  ) {}

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }

    await this.auth.refresh()
    this.user = await Auth.currentAuthenticatedUser();
    this.owner = this.route.snapshot.queryParamMap.get('owner');
    this.transactionList = [];
    if (this.owner) {
      await this.getTransactionList(this.owner);
      // Obtener el phoneNumber desde los detalles del usuario
      const phoneNumber = await this.getPhoneNumberFromUser(this.owner);
      await this.getbalance(this.owner, phoneNumber);
    } else {
      await this.getTransactionList();
    }

  }

  async getPhoneNumberFromUser(owner: string): Promise<string | undefined> {
    try {
      const data = await this.lambda.getLambdaFunction("lambda", "/get/userDetails", {
        queryStringParameters: {
          sub: owner
        }
      });
      return data?.phone_number;
    } catch (error) {
      console.error("Error al obtener detalles del usuario:", error);
      return undefined;
    }
  }

  async getbalance(owner: string, phoneNumber?: string) {
  try {
    const queryParams: any = {
      owner,
      action: "get"
    };

    // Añadir phoneNumber si está disponible
    if (phoneNumber) {
      queryParams.phoneNumber = phoneNumber;
    }

    const response = await this.lambda.getLambdaFunction('lambda', '/transactions/balance', {
      queryStringParameters: queryParams
    });
    this.balanceAmount = response.amount;
  } catch (err) {
    console.error("Error al obtener el balance:", err);
    this.balanceAmount = null;
  }
}


  async getTransactionList(owner?: string): Promise<void> {
    if (this.loadingTransactions || !this.hasMoreTransactions) return;
    this.loadingTransactions = true;
    const queryParams: any = {};
    if (owner) queryParams.owner = owner;


    try {
      let response;
      response = await this.lambda.getLambdaFunction('lambda', '/get/transfers', {
          queryStringParameters: queryParams,
      });

      if (response && response.data && Array.isArray(response.data)) {
        this.transactionList = [...this.transactionList, ...response.data];

        // Ordenar por fecha de más reciente a más antiguo
        this.transactionList.sort((a, b) => {
          const dateA = new Date(a.createdAt).getTime();
          const dateB = new Date(b.createdAt).getTime();
          return dateB - dateA; // Descendente (más reciente primero)
        });

        console.log('Transacciones obtenidas:',this.transactionList);
        const uniqueStatuses = Array.from(
          new Set(response.data.map((transaction: { type: any }) => transaction.type))
        ).map(type => ({
          key: type,
          value: type
        }));

        const uniqueSources = Array.from(
          new Set(response.data.map((transaction: { source: any }) => transaction.source))
        ).map(source => ({
          key: source,
          value: source
        }));
        
        const uniqueDestinations = Array.from(
          new Set(response.data.map((transaction: { destination: any }) => transaction.destination))
        ).map(destination => ({
          key: destination,
          value: destination
        }));

        this.filterTransactions = [
          { key: 'amount', type: 'text', label: "cantidad" },
          { key: 'source', type: 'select', label:"source" ,options: uniqueSources },
          { key: 'destination', type: 'select', label: "destino" ,options: uniqueDestinations },
          { key: 'phonenumber', type: 'text', label: "phonenumber" },
          { key: 'type', type: 'select', label: "status",options: uniqueStatuses  },
          // { key: 'amount', type: 'text', label: this.translate.instant('COMPONENTS.TRANSACTION.AMOUNT') },
          // { key: 'source', type: 'text', label: this.translate.instant('COMPONENTS.TRANSACTION.SOURCE') },
          // { key: 'destination', type: 'text', label: this.translate.instant('COMPONENTS.TRANSACTION.DESTINATION') },
          // { key: 'owner', type: 'text', label: this.translate.instant('COMPONENTS.TRANSACTION.OWNER') },
          // { key: 'status', type: 'select', label: this.translate.instant('COMPONENTS.TRANSACTION.STATUS'), options: uniqueStatuses },
        ];
      } else {
        this.hasMoreTransactions = false;
      }
    } catch (error) {
      console.error('Error al obtener transacciones:', error);
    } finally {
      this.loadingTransactions = false;
    }
  }

  async loadMoreTransactions(): Promise<void> {
    // if (this.hasMoreTransactions) {
    //   await this.getTransactionList();
    // }
  }

  onFiltersChanged(filters: any) {
    console.log('Filters updated:', filters);
  }

  onTransactionClick(transaction: any): void {
    this.router.navigate(['/backoffice/transactions/detail'], {
      queryParams: { id: transaction.id},
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}